import script from "./pp-stastne-datum-winnings.vue?vue&type=script&lang=ts&setup=true"
export * from "./pp-stastne-datum-winnings.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__